import { Button } from "@/atoms"
import { ConnectPlug } from "@/icons"
import { Protected } from "@/molecules/Protected"

import type { ConnectButtonProps } from "./ConnectButton.types"

export const ConnectButton = (props: ConnectButtonProps) => (
  <Protected
    permission={{ resource: "integrations", action: "write" }}
    shouldDisable
  >
    <Button icon={<ConnectPlug />} type="primary" {...props} />
  </Protected>
)
